import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import Button from '@mui/material/Button';
import { SigninIcon } from '@fluentui/react-icons-mdl2';

async function  handleLogin(instance) {
    instance.loginRedirect(loginRequest).catch(e => {
        console.log("login error popup", e)
        //console.error(e);
    });
    const account = instance.getAllAccounts()
    if (account.length === 0) {
        await instance.loginRedirect(loginRequest).catch(e => {
            console.log("login error redirect", e)
            //console.error(e);
        });
    } 
    
}

/**
 * Renders a button which, when selected, will open a popup for login
 */
export const AadSignin = () => {
    const { instance } = useMsal();

    return (
        <Button variant="contained" component="label" startIcon={<SigninIcon />} onClick={() => handleLogin(instance)}>Sign in using Outlook</Button>
    );
}